import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AcessoPDFIdentificacao } from '../../../shared/util/dados-documentos-institucional/acesso-pdfs-identificadores';

@Injectable()
export class AcessoLinksDocumentosService {


  mudouLayout = new EventEmitter<Boolean>();

  constructor(private httpClient: HttpClient) { }



  getDocumentosLista(id: string): Promise<any> {

    return new Promise(function resolvePromise(resolve, reject) {
      return resolve(AcessoPDFIdentificacao.acessoPDFIdentificacaoLista.find(item => item.id.toLowerCase().indexOf(id.toLowerCase()) !== -1))
    })

  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/institucional/acesso-links-documentos/service/acesso-links-documentos.service.ts